import { USER_FOUND, USER_EXPIRED, SESSION_TERMINATED, USER_SIGNED_OUT } from "redux-oidc";
import { requestBO, requestFile } from "@redux/Config";
import { checkJsonProp } from "@utilities";

let admin = JSON.parse(sessionStorage.getItem("admin"));
const initialState = admin ? { loggedIn: true, admin: admin } : {};

if (admin) {
  requestBO.defaults.headers.common["Authorization"] = getToken(admin);
  requestFile.defaults.headers.common["Authorization"] = getToken(admin);
  requestFile.defaults.headers.common["content-type"] = "multipart/form-data";
}

function getToken(user) {
  let tokenType = checkJsonProp(user, "token_type");
  let access_token = checkJsonProp(user, "access_token");
  return tokenType + " " + access_token;
}

export const loginOIDCReducer = function(state = initialState, action) {
  switch (action.type) {
    case USER_FOUND:
      sessionStorage.setItem("admin", JSON.stringify(action.payload));
      requestBO.defaults.headers.common["Authorization"] = getToken(action.payload);
      return {
        ...state,
        admin: action.payload
      };
    case USER_EXPIRED:
    case USER_SIGNED_OUT:
    case SESSION_TERMINATED:
      return {
        ...state,
        admin: null
      };
    default:
      return state;
  }
};
